export default "<div class=\"hintText\">{{hintText}}</div>"